module.exports = __webpack_public_path__ + "img/chipin-plus-rounded.234573e3.svg";